import { render, staticRenderFns } from "./authClueCarRecord.vue?vue&type=template&id=6c84db00&scoped=true"
import script from "./authClueCarRecord.vue?vue&type=script&lang=js"
export * from "./authClueCarRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84db00",
  null
  
)

export default component.exports